// @generated by protobuf-ts 2.9.4 with parameter generate_dependencies,optimize_code_size
// @generated from protobuf file "core/v1/tax.proto" (package "core.v1", syntax proto3)
// tslint:disable
import { MessageType } from "@protobuf-ts/runtime";
import { Date } from "./date";
// Tax inputs shaped like the documents a user actually has (architecture-redesign.md item J §2), plus
// the year-to-date and carry-forward facts the engine needs so its state is one-to-one with Family
// (docs/design/DEVIATIONS.md). All amounts are CAD.

/**
 * CRA Notice of Assessment for one tax year. Also the person's tax history: the engine uses the last
 * five years (OAS clawback base, carry-forwards, RRSP limit).
 *
 * @generated from protobuf message core.v1.NoticeOfAssessment
 */
export interface NoticeOfAssessment {
    /**
     * @generated from protobuf field: int32 tax_year = 1;
     */
    taxYear: number;
    /**
     * @generated from protobuf field: optional double total_income = 2;
     */
    totalIncome?: number; // line 15000
    /**
     * @generated from protobuf field: optional double net_income = 3;
     */
    netIncome?: number; // line 23600
    /**
     * @generated from protobuf field: optional double taxable_income = 4;
     */
    taxableIncome?: number; // line 26000
    /**
     * @generated from protobuf field: optional double total_tax_payable = 5;
     */
    totalTaxPayable?: number; // federal + provincial, after credits
    /**
     * @generated from protobuf field: optional double balance_owing = 6;
     */
    balanceOwing?: number; // negative = refund
    /**
     * @generated from protobuf field: optional double rrsp_deduction_limit_next_year = 7;
     */
    rrspDeductionLimitNextYear?: number;
    /**
     * @generated from protobuf field: optional double unused_rrsp_contributions = 8;
     */
    unusedRrspContributions?: number; // available to deduct in a later year
    /**
     * @generated from protobuf field: optional double net_capital_loss_carryforward = 9;
     */
    netCapitalLossCarryforward?: number;
    /**
     * @generated from protobuf field: optional double tuition_carryforward = 10;
     */
    tuitionCarryforward?: number;
}
/**
 * CRA My Account room figures, as of a date.
 *
 * @generated from protobuf message core.v1.CraRoomStatement
 */
export interface CraRoomStatement {
    /**
     * @generated from protobuf field: core.v1.Date as_of_date = 1;
     */
    asOfDate?: Date;
    /**
     * @generated from protobuf field: optional double tfsa_room = 2;
     */
    tfsaRoom?: number;
    /**
     * @generated from protobuf field: optional double fhsa_participation_room = 3;
     */
    fhsaParticipationRoom?: number;
    /**
     * @generated from protobuf field: optional double rrsp_deduction_limit = 4;
     */
    rrspDeductionLimit?: number;
}
/**
 * Employer T4 slip for one job and tax year.
 *
 * @generated from protobuf message core.v1.T4Slip
 */
export interface T4Slip {
    /**
     * @generated from protobuf field: int32 tax_year = 1;
     */
    taxYear: number;
    /**
     * @generated from protobuf field: string job_uuid = 2;
     */
    jobUuid: string;
    /**
     * @generated from protobuf field: optional double employment_income = 3;
     */
    employmentIncome?: number; // box 14
    /**
     * @generated from protobuf field: optional double cpp_contributions = 4;
     */
    cppContributions?: number; // box 16
    /**
     * @generated from protobuf field: optional double ei_premiums = 5;
     */
    eiPremiums?: number; // box 18
    /**
     * @generated from protobuf field: optional double pension_adjustment = 6;
     */
    pensionAdjustment?: number; // box 52
    /**
     * @generated from protobuf field: optional double income_tax_deducted = 7;
     */
    incomeTaxDeducted?: number; // box 22
}
/**
 * Registered-plan room and contributions as of Family.facts_as_of. When a CRA document is newer
 * than these, the engine rolls the document forward instead (item J §2 "Rolling forward").
 *
 * @generated from protobuf message core.v1.RegisteredRoom
 */
export interface RegisteredRoom {
    /**
     * @generated from protobuf field: optional double tfsa_room = 1;
     */
    tfsaRoom?: number;
    /**
     * @generated from protobuf field: optional double tfsa_withdrawals_this_year = 2;
     */
    tfsaWithdrawalsThisYear?: number; // restored to room next 1 January
    /**
     * @generated from protobuf field: optional double rrsp_deduction_limit = 3;
     */
    rrspDeductionLimit?: number;
    /**
     * @generated from protobuf field: optional double rrsp_unused_contributions = 4;
     */
    rrspUnusedContributions?: number; // contributed but not yet deducted
    /**
     * @generated from protobuf field: optional double rrsp_contributions_this_year = 5;
     */
    rrspContributionsThisYear?: number;
    /**
     * @generated from protobuf field: optional double fhsa_participation_room = 6;
     */
    fhsaParticipationRoom?: number;
    /**
     * @generated from protobuf field: optional double fhsa_carryforward = 7;
     */
    fhsaCarryforward?: number;
    /**
     * @generated from protobuf field: optional double fhsa_lifetime_contributions = 8;
     */
    fhsaLifetimeContributions?: number;
    /**
     * @generated from protobuf field: optional bool fhsa_qualifying_withdrawal_made = 9;
     */
    fhsaQualifyingWithdrawalMade?: boolean;
}
/**
 * Tax-year-to-date facts as of Family.facts_as_of.
 *
 * @generated from protobuf message core.v1.TaxYearToDate
 */
export interface TaxYearToDate {
    /**
     * @generated from protobuf field: int32 tax_year = 1;
     */
    taxYear: number;
    /**
     * @generated from protobuf field: optional double cpp_contributions = 2;
     */
    cppContributions?: number;
    /**
     * @generated from protobuf field: optional double ei_premiums = 3;
     */
    eiPremiums?: number;
    /**
     * @generated from protobuf field: optional double income_tax_withheld = 4;
     */
    incomeTaxWithheld?: number;
    /**
     * @generated from protobuf field: optional double realized_capital_gains = 5;
     */
    realizedCapitalGains?: number; // net of losses
    /**
     * @generated from protobuf field: optional double oas_received = 6;
     */
    oasReceived?: number;
    /**
     * @generated from protobuf field: optional double rrif_withdrawals = 7;
     */
    rrifWithdrawals?: number;
    /**
     * @generated from protobuf field: optional double irregular_income = 8;
     */
    irregularIncome?: number; // bonuses and other non-salary employment income
}
/**
 * Old Age Security residence (prototype Sharpen item "oas").
 *
 * @generated from protobuf message core.v1.OasResidency
 */
export interface OasResidency {
    /**
     * @generated from protobuf field: optional int32 years_in_canada_after_18 = 1;
     */
    yearsInCanadaAfter18?: number;
    /**
     * Countries with a social security agreement that the person lived or worked in.
     *
     * @generated from protobuf field: repeated string agreement_countries = 2;
     */
    agreementCountries: string[];
}
/**
 * Money already owed to or by the household that will arrive on a known date.
 *
 * @generated from protobuf message core.v1.PendingPayment
 */
export interface PendingPayment {
    /**
     * @generated from protobuf field: string uuid = 1;
     */
    uuid: string;
    /**
     * @generated from protobuf field: core.v1.PendingPayment.Kind kind = 2;
     */
    kind: PendingPayment_Kind;
    /**
     * @generated from protobuf field: double amount = 3;
     */
    amount: number;
    /**
     * @generated from protobuf field: core.v1.Date expected_date = 4;
     */
    expectedDate?: Date;
    /**
     * @generated from protobuf field: string account_uuid = 5;
     */
    accountUuid: string; // where it lands or is paid from; empty = chequing
}
/**
 * @generated from protobuf enum core.v1.PendingPayment.Kind
 */
export enum PendingPayment_Kind {
    /**
     * @generated from protobuf enum value: KIND_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: KIND_TAX_REFUND = 1;
     */
    TAX_REFUND = 1,
    /**
     * @generated from protobuf enum value: KIND_TAX_OWING = 2;
     */
    TAX_OWING = 2,
    /**
     * @generated from protobuf enum value: KIND_CESG = 3;
     */
    CESG = 3,
    /**
     * @generated from protobuf enum value: KIND_CLB = 4;
     */
    CLB = 4,
    /**
     * @generated from protobuf enum value: KIND_OTHER = 5;
     */
    OTHER = 5
}
// @generated message type with reflection information, may provide speed optimized methods
class NoticeOfAssessment$Type extends MessageType<NoticeOfAssessment> {
    constructor() {
        super("core.v1.NoticeOfAssessment", [
            { no: 1, name: "tax_year", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "total_income", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "net_income", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "taxable_income", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "total_tax_payable", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "balance_owing", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "rrsp_deduction_limit_next_year", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 8, name: "unused_rrsp_contributions", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 9, name: "net_capital_loss_carryforward", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 10, name: "tuition_carryforward", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.NoticeOfAssessment
 */
export const NoticeOfAssessment = new NoticeOfAssessment$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CraRoomStatement$Type extends MessageType<CraRoomStatement> {
    constructor() {
        super("core.v1.CraRoomStatement", [
            { no: 1, name: "as_of_date", kind: "message", T: () => Date },
            { no: 2, name: "tfsa_room", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "fhsa_participation_room", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "rrsp_deduction_limit", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.CraRoomStatement
 */
export const CraRoomStatement = new CraRoomStatement$Type();
// @generated message type with reflection information, may provide speed optimized methods
class T4Slip$Type extends MessageType<T4Slip> {
    constructor() {
        super("core.v1.T4Slip", [
            { no: 1, name: "tax_year", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "job_uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "employment_income", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "cpp_contributions", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "ei_premiums", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "pension_adjustment", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "income_tax_deducted", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.T4Slip
 */
export const T4Slip = new T4Slip$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RegisteredRoom$Type extends MessageType<RegisteredRoom> {
    constructor() {
        super("core.v1.RegisteredRoom", [
            { no: 1, name: "tfsa_room", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "tfsa_withdrawals_this_year", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "rrsp_deduction_limit", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "rrsp_unused_contributions", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "rrsp_contributions_this_year", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "fhsa_participation_room", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "fhsa_carryforward", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 8, name: "fhsa_lifetime_contributions", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 9, name: "fhsa_qualifying_withdrawal_made", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.RegisteredRoom
 */
export const RegisteredRoom = new RegisteredRoom$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaxYearToDate$Type extends MessageType<TaxYearToDate> {
    constructor() {
        super("core.v1.TaxYearToDate", [
            { no: 1, name: "tax_year", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "cpp_contributions", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "ei_premiums", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "income_tax_withheld", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "realized_capital_gains", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "oas_received", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "rrif_withdrawals", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 8, name: "irregular_income", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.TaxYearToDate
 */
export const TaxYearToDate = new TaxYearToDate$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OasResidency$Type extends MessageType<OasResidency> {
    constructor() {
        super("core.v1.OasResidency", [
            { no: 1, name: "years_in_canada_after_18", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "agreement_countries", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.OasResidency
 */
export const OasResidency = new OasResidency$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PendingPayment$Type extends MessageType<PendingPayment> {
    constructor() {
        super("core.v1.PendingPayment", [
            { no: 1, name: "uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "kind", kind: "enum", T: () => ["core.v1.PendingPayment.Kind", PendingPayment_Kind, "KIND_"] },
            { no: 3, name: "amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "expected_date", kind: "message", T: () => Date },
            { no: 5, name: "account_uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.PendingPayment
 */
export const PendingPayment = new PendingPayment$Type();
